import * as actionTypes from "../Actions/ActionTypes";
const intialState = {
  books: [],
  bookDetail: [],
  loading: false,
  addedBooks: [],
  filterData: [],
  countries: [],
  address: [],
  itemAdded: false,
  orderID: "",
  quantity: 0,
  total: 0,
  shippingCharge: 0,
  orderStatus: [],
  orderConfirmed: false,
  selectedFilter: [],
  booksFetched: [],
  textbook: [],
  collegeBooks: [],
  samplePapers: [],
  pincodeLoading: false,
  outsideIndiaDelivary: null,
  totalPage: 0,
  paginationAval: false,
  savePayloadData: [],
  bestSellerBooks: [],
  inputBookType: "",
};

const Books = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_BOOK_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.FETCH_BOOKS: {
      return {
        ...state,
        books: action.books.data,
        loading: false,
        paginationAval: false,
      };
    }
    case actionTypes.INIT_FETCH_BOOK_DETAIL: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.FETCH_BOOK_DETAIL: {
      return {
        ...state,
        bookDetail: action.bookDetail,
        loading: false,
      };
    }
    case actionTypes.GET_BOOK_BY_INPUT_TYPE: {
      return {
        ...state,
        inputBookType: action.bookType,
        paginationAval: true,
      };
    }
    case actionTypes.FETCH_GOOGLE_BOOKS: {
      return {
        ...state,
        books: action.books.data,
        loading: false,
        totalPage: action.totalPage,

      };
    }
    //filtering Data
    case actionTypes.INIT_FILTER_ITEM: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.FILTER_ITEM: {
      return {
        ...state,
        books: action.filterData,
        totalPage: action.totalPage,
        loading: false,
        paginationAval: true,
      };
    }

    case actionTypes.GET_SELECTED_FILTERS: {
      return {
        ...state,
        selectedFilter: action.filterData,
      };
    }

    // cart
    case actionTypes.ADD_ITEM: {
      let addedBook = [];
      addedBook = state.bookDetail.find((book) => book.bmid === action.bookId);

      let existedItem = state.addedBooks.find(
        (item) => item.bmid === action.bookId
      );
      if (existedItem) {
        addedBook.quantity += 1;
        addedBook.totalBookPrice =
          Number(addedBook.quantity) * Number(addedBook.price);
          addedBook.book_mediums_id = addedBook.bmid
        return {
          ...state,
          available: true,
        };
      } else {
        addedBook.quantity = 1;
        addedBook.totalBookPrice = Number(addedBook.price);
        addedBook.book_mediums_id = addedBook.bmid

        // console.log(addedBook)
        return {
          ...state,
          addedBooks: [...state.addedBooks, addedBook],
          available: false,
          itemAdded: true,
        };
      }
    }
    case actionTypes.INCREASE_ITEM: {
      let increaseBook = [];
      increaseBook = state.addedBooks.find(
        (book) => book.bmid === action.increasedIemID
      );
      increaseBook.quantity += 1;
      increaseBook.totalBookPrice =
        Number(increaseBook.quantity) * Number(increaseBook.price);
      return {
        ...state,
        addedBooks: [...state.addedBooks],
      };
    }
    case actionTypes.DECREASE_ITEM: {
      let decreaseBook = [];
      decreaseBook = state.addedBooks.find(
        (book) => book.bmid === action.decreaseItemId
      );
      decreaseBook.quantity -= 1;
      if (decreaseBook.quantity === 0) {
        let removeItems = state.addedBooks.filter(
          (book) => book.bmid !== action.decreaseItemId
        );

        return {
          ...state,
          addedBooks: removeItems,
          itemAdded: false,
        };
      } else {
        decreaseBook.totalBookPrice =
          Number(decreaseBook.quantity) * Number(decreaseBook.price);
        return {
          ...state,
          addedBooks: [...state.addedBooks],
        };
      }
    }

    case actionTypes.GET_COUNTRY_LIST: {
      return {
        ...state,
        countries: action.country,
      };
    }

    case actionTypes.ORDER_BOOKED: {
      return {
        ...state,
        orderID: action.orderDetail,
      };
    }

    case actionTypes.USER_SHIPPING_ADDRESS: {
      return {
        ...state,
        address: action.userAddress,
      };
    }
    case actionTypes.CHECKOUT: {
      return {
        ...state,
        shippingCharge: action.shippingCharge,
      };
    }
    case actionTypes.PAYMENT_SUCCESS: {
      return {
        ...state,
        orderStatus: action.orderStatus,
        orderConfirmed: true,
      };
    }
    case actionTypes.CLEAR_REDUCER: {
      return {
        ...state,
        addedBooks: [],
        itemAdded: false,
        orderConfirmed: true,
      };
    }
    case actionTypes.GET_BOOK_BY_TYPE: {
      return {
        ...state,
        books: action.textbook.data.concat(
          action.collegeBooks.data,
          action.samplePapers.data
        ),
        textbook: action.textbook,
        collegeBooks: action.collegeBooks,
        samplePapers: action.samplePapers,
      };
    }
    case actionTypes.INIT_CHECK_PINCODE: {
      return {
        ...state,
        pincodeLoading: true,
      };
    }
    case actionTypes.CHECK_PINCODE: {
      return {
        ...state,
        outsideIndiaDelivary: action.availability,
        pincodeLoading: false,
      };
    }
    case actionTypes.INIT_PUBLISH_WITH_US: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.PUBLISH_WITH_US: {
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.PUBLISH_WITH_US_ERROR_HANDLER: {
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.INIT_GET_SAMPLE_COPY: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.GET_SAMPLE_COPY: {
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.GET_SAMPLE_COPY_ERROR_HANDLER: {
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.INIT_PAGINATION: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.PAGINATED_BOOKS: {
      return {
        ...state,
        books: action.books,
        loading: false,
      };
    }
    case actionTypes.SAVE_PAYLOAD: {
      return {
        ...state,
        savePayloadData: action.payload,
      };
    }
    default:
      return state;
  }
};

export default Books;
